<template>
  <div class="form-group" :class="computedClasses">
      <vue-timepicker
        :input-class="[...inputClasses, {'form-control': true}]"
        :class="inputClasses"
        :name="name"
        :id="id"
        :format="format"
        :placeholder="placeholder"
        auto-scroll
        close-on-complete

        v-model="valueCopy"

        :readonly="readonly"
        :disabled="disabled"

        :required="required"

        @focus="handleFocus(true)"
        @blur="handleFocus(false)"
        @change="changeHandler"
      ></vue-timepicker>

      <label class="material-label" :class="activeClass" :for="id">
        <slot></slot>
      </label>
      <small v-if="error" class="invalid-feedback">{{ error }}</small>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src'

export default {
    name: 'material-timepicker',
    components: {
        VueTimepicker
    },
    props: {
        id: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        value: {
            default: null
        },
        placeholder: {
            type: String,
            default: ' '
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            type: [Array, String],
            default: null
        },
        inputClasses: {
            type: [Array, Object, String],
            default: null
        },
        error: {
            type: String,
            default: null
        },
        helpText: {
            type: String,
            default: null
        },
        format: {
            type: String,
            default: "HH:mm"
        }
    },
    data() {
        return {
            valueCopy: null,
            focus: false,
            valid: true
        }
    },
    computed: {
        computedErrors () {
            return typeof this.errorMessages === 'string'
            ? [this.errorMessages] : this.errorMessages
        },
        computedClasses () {
            return {
            'material--active': this.focus,
            'material--disabled': this.disabled,
            'material--has-errors': Boolean(
                !this.valid ||
                (this.errorMessages && this.errorMessages.length)),
            'material--raised': Boolean(
                this.focus ||
                this.valueCopy || // has value
                (this.placeholder && !this.valueCopy)) // has placeholder
            }
        },
        activeClass () {
            return {
            'active': Boolean(
                this.focus ||
                this.valueCopy || // has value
                (this.placeholder && !this.valueCopy)) // has placeholder
            }
        },
        grpAppendSlot() {
            if (this.$scopedSlots) {
                return this.$scopedSlots.grpAppend;
            }
            return null;
        },
    },
    methods: {
        changeHandler (eventData) {
            this.valueCopy = eventData.displayTime
            this.$emit('input', this.valueCopy)
            this.handleValidation()
        },
        handleFocus (focused) {
            this.focus = focused
        },
        handleValidation () {
            this.valid = this.$el ? this.$el.querySelector('.form-control').validity.valid : this.valid
        },
        copyValue (value) {
            this.valueCopy = value
            this.handleValidation()
        },
        onKeyDown(event) {
            this.$emit('keyDown', event)
        },
        onKeyUp(event) {
            this.$emit('keyUp', event)
        },
        onKeyEnter(event) {
            this.$emit('keyEnter', event)
        },
    },
    watch: {
        value: {
            immediate:true,
            handler: function(newValue) {
                this.copyValue(newValue)
            },
        }
    },
}
</script>

<style>
    .vue__time-picker {
        width: 100% !important;
    }

    .vue__time-picker input.display-time {
        height: initial !important;
        font-size: 1rem !important;
        width: 100% !important;
    }

    .vue__time-picker .dropdown {
        top: initial !important
    }
</style>